import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { APP_LANGUAGE } from '../../shared/enums';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANGUAGE_KEY = 'language';

  constructor(private readonly translate: TranslateService) {
    const lang = this.getStoredOrBrowserLanguage();
    this.setLanguage(lang, false);

    window.addEventListener('CookiebotOnConsentReady', () => {
      if ((window as any).Cookiebot?.changed) {
        const consent = (window as any).Cookiebot?.consent;
        if (!(consent && consent.preferences && consent.statistics && consent.marketing)) {
          window.location.reload();
        }
      }
    });

    window.addEventListener('CookiebotOnAccept', () => {
      if ((window as any).Cookiebot?.consent?.preferences) {
        const currentLang = this.translate.currentLang as APP_LANGUAGE;
        localStorage.setItem(this.LANGUAGE_KEY, currentLang);
      }
    });
  }

  private getStoredOrBrowserLanguage(): APP_LANGUAGE {
    const storedLang = localStorage.getItem(this.LANGUAGE_KEY)?.toLowerCase() as APP_LANGUAGE;

    if (storedLang && Object.values(APP_LANGUAGE).includes(storedLang)) {
      return storedLang;
    }

    const browserLang = navigator.language.toLowerCase();
    return browserLang.startsWith('ru') || browserLang.startsWith('uk') ? APP_LANGUAGE.UK : APP_LANGUAGE.EN;
  }

  getCurrentLanguage(): APP_LANGUAGE {
    return this.translate.currentLang as APP_LANGUAGE;
  }

  setLanguage(lang: APP_LANGUAGE, reload: boolean = true): void {
    if (this.translate.currentLang !== lang) {
      if ((window as any).Cookiebot?.consent?.preferences) {
        localStorage.setItem(this.LANGUAGE_KEY, lang);
      }

      if (reload) {
        window.location.reload();
      } else {
        this.translate.use(lang);
      }
    } else {
      this.translate.use(lang);
    }
  }
}
